import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCRMBaseUrl, getUserCurrentOrganization } from '../../modules/Auth/AuthReducer'
import { getContactUrl } from '../../util/crm-url';

class ContactNameRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      value, data, crmBaseUrl, organization,
    } = this.props;
    if (!data) {
      return null;
    }
    const name = value || data.name;
    if (crmBaseUrl && data && data.contact_id) {
      const url = getContactUrl(organization, data);
      if (url) {
        return (
          <a rel="noreferrer" target="_blank" href={url}>{name}</a>
        );
      }
    }
    return <span>{name}</span>;
  }
}

ContactNameRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    contact_id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  organization: PropTypes.shape({
    type: PropTypes.string,
  }),
  crmBaseUrl: PropTypes.string,
  children: PropTypes.node,
};
ContactNameRenderer.defaultProps = {
  value: null,
  data: null,
  crmBaseUrl: null,
  children: null,
};

function mapStateToProps(state) {
  return {
    crmBaseUrl: getCRMBaseUrl(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(ContactNameRenderer);
